<template>
	<div class="article main-content" v-loading="loading">
		<div v-if="articleDetail" class="no-border">
			<p class="article-content-title">{{ articleDetail.title }}</p>
			<div class="article-content-info-block">
				<span class="article-content-info-time" title="发布时间">
					<i class="el-icon-fa-calendar"></i>
					{{ articleDetail.created_at }}
				</span>
				<span class="article-content-info-time" title="作者">
					<i class="el-icon-fa-user"></i>
					{{ articleDetail.author }}
				</span>
				<span class="article-content-info-time" title="显示状态">
					<i class="el-icon-fa-lock"></i>
					{{ articleDetail.status === 1 ? '显示' : '禁用' }}
				</span>
				<span class="article-content-info-time" title="浏览量">
					<i class="el-icon-fa-eye"></i>
					{{ articleDetail.review }}
				</span>
			</div>

			<div class="article-content-content" v-html="articleDetail.content"></div>
		</div>
	</div>
</template>

<script>
import { getData } from '../../http'
export default {
	data() {
		return {
			articleDetail: undefined,
			loading: false
		}
	},
	props: {
		article_id: String
	},
	created() {
		this.loading = true
		getData(`articles/${this.article_id}`)
			.then(
				res => {
					this.articleDetail = res.data
				}
			)
			.finally(() => {
				this.loading = false
			})
	}
}
</script>

<style>
.article-item-title {
	margin: 0;
	font-size: 20px;
	color: #333333;
	overflow: hidden;
	font-weight: 600;
}
.project-content-card-article-item {
	padding: 10px 15px;
	cursor: pointer;
	border-bottom: solid 1px #efefef;
	margin: 0px 10px;
}
.project-content-card-article-item:hover .article-item-title {
	color: #409eff;
}
.article-item-footer {
	display: block;
	height: 2em;
}
.article-item-footer-left {
	float: left;
	margin-top: 10px;
}
.article-item-footer-right {
	float: right;
	margin-top: 10px;
}
.article-item-time {
	display: inline-block;
	margin: 0px;
}

.article-content-title {
	margin: 0;
	font-size: 24px;
	color: #333333;
	overflow: hidden;
	font-weight: 600;

	text-align: left;
}
.article-content-info-block {
	display: block;
	text-align: left;
	margin-top: 10px;
	margin-bottom: 10px;
}
.article-content-info-time {
	color: #666666;
	font-size: 14px;
	letter-spacing: -0.5px;
	margin-right: 10px;
}
.article-content-content {
	display: block;
	text-align: left;

	padding: 10px 0px;
}
.article-content-content p {
	margin: 0 0 10px;

	color: #333;
	font-size: 16px;
	line-height: 2em;
	text-align: justify;
}
</style>
